import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { FormikSelect } from 'components';
import { PayoutDisputeStatusDetails } from 'enums';
import { TranslationNamespace } from 'i18n';
import { orderUtils } from 'utils';

type Props = {
  name?: string;
};

export const DisputeSelect: React.FC<Props> = ({ name = 'statusDetails' }) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'features.orders',
  });
  const options = useMemo(
    () =>
      [
        PayoutDisputeStatusDetails.DisputeInvalidRequisites,
        PayoutDisputeStatusDetails.DisputePaymentFailed,
      ].map((value) => ({
        value,
        label: orderUtils.getPayoutStatusDetailsLabel(value),
      })),
    [],
  );

  return (
    <FormikSelect
      label={t('resolve.reason')}
      name={name}
      noneOption={false}
      options={options}
      fullWidth
      size="small"
    />
  );
};
